import React from "react";
import PropTypes from "prop-types";

import { FIELD_TYPE } from "../../hooks/useConditionController";
import { FormFieldCondition, StreamTagCondition, WorkflowCondition } from "..";

export function ConditionRenderer({ type, ...props }) {
  switch (type) {
    case FIELD_TYPE.STREAM_AND_TAG:
      return <StreamTagCondition {...props} />;
    case FIELD_TYPE.THIS_WORKFLOW:
      return <WorkflowCondition {...props} />;
    case FIELD_TYPE.FORM_FIELD:
      return <FormFieldCondition {...props} />;
    default:
      return null;
  }
}

ConditionRenderer.propTypes = {
  type: PropTypes.string,
};

ConditionRenderer.defaultProps = {
  type: "",
};

export default ConditionRenderer;
